import { BM, } from './backend';
import { ClassList, StyleScopeManager } from './class_list';
import { Element } from './element';
import { ENV, globalOptions } from './global_options';
import { performanceMeasureEnd, performanceMeasureStart } from './dev_tools';
import { NATIVE_NODE_SYMBOL, isNativeNode } from './type_symbol';
export class NativeNode extends Element {
    /* @internal */
    /* istanbul ignore next */
    constructor() {
        throw new Error('Element cannot be constructed directly');
        // eslint-disable-next-line no-unreachable
        super();
    }
    /* @internal */
    static create(tagName, owner, stylingName) {
        const node = Object.create(NativeNode.prototype);
        node.stylingName = stylingName !== null && stylingName !== void 0 ? stylingName : tagName;
        const nodeTreeContext = owner.getBackendContext();
        let backendElement = null;
        if (nodeTreeContext) {
            if (ENV.DEV)
                performanceMeasureStart('backend.createElement');
            if (BM.DOMLIKE || (BM.DYNAMIC && owner.getBackendMode() === 3 /* BackendMode.Domlike */)) {
                backendElement = nodeTreeContext.document.createElement(tagName);
            }
            else if (BM.SHADOW || (BM.DYNAMIC && owner.getBackendMode() === 1 /* BackendMode.Shadow */)) {
                backendElement = owner._$backendShadowRoot.createElement(tagName, node.stylingName);
            }
            else {
                const backend = nodeTreeContext;
                backendElement = backend.createElement(tagName, node.stylingName);
            }
            if (ENV.DEV)
                performanceMeasureEnd();
        }
        node._$initialize(tagName, false, backendElement, owner, owner._$nodeTreeContext);
        const ownerHost = owner.getHostNode();
        const [styleScope, extraStyleScope, styleScopeManager] = ownerHost.getStyleScopes();
        node.classList = new ClassList(node, undefined, ownerHost.classList, styleScope !== null && styleScope !== void 0 ? styleScope : StyleScopeManager.globalScope(), extraStyleScope !== null && extraStyleScope !== void 0 ? extraStyleScope : undefined, styleScopeManager);
        if (backendElement) {
            if (BM.COMPOSED || (BM.DYNAMIC && owner.getBackendMode() === 2 /* BackendMode.Composed */)) {
                if (ENV.DEV)
                    performanceMeasureStart('backend.setStyleScope');
                backendElement.setStyleScope(styleScope !== null && styleScope !== void 0 ? styleScope : StyleScopeManager.globalScope(), extraStyleScope !== null && extraStyleScope !== void 0 ? extraStyleScope : undefined);
                if (ENV.DEV)
                    performanceMeasureEnd();
            }
            if (globalOptions.writeExtraInfoToAttr) {
                const prefix = styleScopeManager.queryName(styleScope !== null && styleScope !== void 0 ? styleScope : StyleScopeManager.globalScope());
                if (prefix) {
                    backendElement.setAttribute('exparser:info-class-prefix', `${prefix}--`);
                }
            }
            if (ENV.DEV)
                performanceMeasureStart('backend.associateValue');
            backendElement.__wxElement = node;
            if (!(BM.DOMLIKE || (BM.DYNAMIC && owner.getBackendMode() === 3 /* BackendMode.Domlike */))) {
                ;
                backendElement.associateValue(node);
            }
            else {
                ;
                owner.getBackendContext().associateValue(backendElement, node);
            }
            if (ENV.DEV)
                performanceMeasureEnd();
        }
        return node;
    }
    setModelBindingListener(propName, listener) {
        if (!this._$modelBindingListeners) {
            this._$modelBindingListeners = Object.create(null);
        }
        if (!this._$modelBindingListeners[propName]) {
            const backendElement = this.getBackendElement();
            if (backendElement) {
                const listener = (value) => {
                    var _a;
                    const listener = (_a = this._$modelBindingListeners) === null || _a === void 0 ? void 0 : _a[propName];
                    if (listener) {
                        listener.call(this, value);
                    }
                };
                if (ENV.DEV)
                    performanceMeasureStart('backend.setModelBindingStat');
                if (BM.DOMLIKE || (BM.DYNAMIC && this.getBackendMode() === 3 /* BackendMode.Domlike */)) {
                    ;
                    this.getBackendContext().setModelBindingStat(backendElement, propName, listener);
                }
                else {
                    ;
                    backendElement.setModelBindingStat(propName, listener);
                }
                if (ENV.DEV)
                    performanceMeasureEnd();
            }
        }
        this._$modelBindingListeners[propName] = listener;
    }
    getModelBindingListeners() {
        const listeners = Object.create(null);
        if (this._$modelBindingListeners) {
            Object.keys(this._$modelBindingListeners).forEach((propName) => {
                const listener = (value) => {
                    var _a;
                    const listener = (_a = this._$modelBindingListeners) === null || _a === void 0 ? void 0 : _a[propName];
                    if (listener) {
                        listener.call(this, value);
                    }
                };
                listeners[propName] = listener;
            });
        }
        return listeners;
    }
}
NativeNode.isNativeNode = isNativeNode;
NativeNode.prototype[NATIVE_NODE_SYMBOL] = true;
//# sourceMappingURL=native_node.js.map